import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    useTranslate,
    useRecordContext,
    required,
    SelectInput,
    minValue,
    NumberInput,
} from 'react-admin';
import { Topics } from '../../custom';
import { EditToolbar } from '../../common/EditToolbar';
import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import { STATUS } from '../../common/constants';
import SlugInput from '../../common/inputs/SlugInput';

const TopicEdit = () => {
    let { programId, subjectId, chapterId, topicId } = useParams();
    if (!chapterId) {
        return <LoadingSection />;
    }
    return (
        <Edit
            mutationMode={'pessimistic'}
            title={<TopicTitle />}
            redirect={() => {
                return `programs/${programId}/subjects/${subjectId}/chapters/${chapterId}/topics`;
            }}
            resource={'topics'}
            id={topicId}
        >
            <SimpleForm toolbar={<EditToolbar />}>
                <TextInput source="name" fullWidth validate={[required()]} />
                <SlugInput source="slug" fullWidth />
                <SelectInput
                    source="status"
                    label={'Status'}
                    fullWidth
                    validate={[required()]}
                    choices={STATUS}
                />
                <NumberInput
                    source="displayOrder"
                    type={'number'}
                    fullWidth
                    validate={[minValue(0)]}
                />
            </SimpleForm>
        </Edit>
    );
};

const TopicTitle = () => {
    const record = useRecordContext<Topics>();
    const translate = useTranslate();

    return record ? (
        <span>
            {translate('resources.topics.name', { smart_count: 1 })} &quot;
            {record.name}&quot;
        </span>
    ) : null;
};

export default TopicEdit;
